<template>
    <keep-alive>
        <component v-bind:is="component" v-bind="getitemprops"  v-on:navigate-to-content-click="onNavigateToContent"></component>
    </keep-alive>
</template>

<script>
import BookDisplay from './BookDisplayPanel'
//import OffRampChapter from './OffRampChapter'

export default {
    components:{
        'book-display':BookDisplay
//        'off-ramp-chapter':OffRampChapter
    },
    data(){
        return{
            props: ['bookprops'],
            myTitle: 'The title of this',
            component:'book-display',
            OffRampChapterUrl: ''
        }
    },
    computed:{
        getitemprops: function(){
            return this.$attrs
        }
    },
    methods:{
        onNavigateToContent: function(url){
            this.component = 'off-ramp-chapter'
            this.OffRampChapterUrl = url
        }
    }
}
</script>